class RepeatOrder {
  constructor(button) {
    this.button = button;
    this.items = JSON.parse(button.dataset.orderItems);
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    try {
      this.setLoading(true);

      const validItems = this.filterValidItems(this.items);

      if (!validItems.length) {
        alert('No reorderable items found in this order.');
        return;
      }

      const availableItems = await this.checkAvailability(validItems);

      if (!availableItems.length) {
        alert('All items from this order are unavailable.');
        return;
      }

      await this.addToCart(availableItems);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      alert('Items added to cart successfully!');
    } catch (e) {
      console.error('Repeat order error:', e);
      alert('Some items could not be added to the cart.');
    } finally {
      this.setLoading(false);
    }
  }

  filterValidItems(items) {
    return items.filter(item => {
      if (!item.variant_id) return false;

      // Skip subscription items (Recurpay, etc.)
      if (item.properties) {
        const hasSubProp = item.properties.some(
          p => p.name && p.name.includes('_recurpay')
        );
        if (hasSubProp) return false;
      }

      return true;
    }).map(item => ({
      id: item.variant_id,
      quantity: item.quantity
    }));
  }

  async checkAvailability(items) {
    const checks = await Promise.all(
      items.map(async (item) => {
        try {
          const res = await fetch(`/variants/${item.id}.js`);
          if (!res.ok) return null;

          const variant = await res.json();
          if (!variant.available) return null;

          return item;
        } catch {
          return null;
        }
      })
    );

    return checks.filter(Boolean);
  }

  async addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      throw new Error('Cart add failed');
    }

    return res.json();
  }

  setLoading(state) {
    this.button.classList.toggle('loading', state);
    this.button.disabled = state;
    this.button.textContent = state ? 'Adding…' : 'Repeat order';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.repeat-order-btn').forEach(btn => {
    new RepeatOrder(btn);
  });
});